import React from 'react'
import { useTranslation } from 'react-i18next'
import { useLicensingPaymentBreakdownCalculations } from '../../../../hooks/useLicensingPaymentBreakdownCalculations'
import {
  BreakdownLedgerForPDF,
  BreakdownLedgerForPDFStyles,
  BreakDownLedgerPDFVariants,
} from './BreakdownLedgerForPDF'

type LicensingFeeSubTotalBreakdownProps = Pick<
  ReturnType<typeof useLicensingPaymentBreakdownCalculations>,
  | 'licensingFeeAdditionalStudent'
  | 'licensingFeeFirstStudent'
  | 'licensingFeeSubtotal'
> &
  BreakdownLedgerForPDFStyles & {
    subHeaderLabel?: string
    displaySubTotalLabel?: boolean
    balanceLabel?: string
  }

export const LicensingFeeSubTotalBreakdown: React.FC<
  LicensingFeeSubTotalBreakdownProps
> = ({
  licensingFeeAdditionalStudent,
  licensingFeeFirstStudent,
  licensingFeeSubtotal,
  subHeaderCellCssProps,
  subHeaderRowCssProps,
  bodyCellCssProps,
  subTotalCellCssProps,
  nestedDescription,
  subHeaderLabel,
  displaySubTotalLabel,
  balanceLabel,
}) => {
  const { t } = useTranslation()

  const licensingFeeApplicationLabel = t(
    'License.PDF.Breakdown.Header.LicenseFee',
    'License Fee - Application'
  )

  return (
    <BreakdownLedgerForPDF
      variant={BreakDownLedgerPDFVariants.Normal}
      headerLabel={subHeaderLabel || licensingFeeApplicationLabel}
      firstStudent={licensingFeeFirstStudent}
      additionalStudent={licensingFeeAdditionalStudent}
      subtotal={licensingFeeSubtotal}
      subHeaderCellCssProps={subHeaderCellCssProps}
      subHeaderRowCssProps={subHeaderRowCssProps}
      bodyCellCssProps={bodyCellCssProps}
      subTotalCellCssProps={subTotalCellCssProps}
      nestedDescription={nestedDescription}
      displaySubTotalLabel={displaySubTotalLabel}
      balanceLabel={balanceLabel}
    />
  )
}
